import React from "react"
import parse from "html-react-parser"
import { Link } from "gatsby"
import StyledImage from "./styled-image"
import CurveTSm from "./icons/curve-t-sm"
import { DocumentTextIcon } from "@heroicons/react/24/outline"
import { Disclosure } from "@headlessui/react"
import Arrow from "./icons/arrow"
import Html from "./html"

export default function Content({ props, translations, hr, index }) {
  const {
    documents,
    image,
    backgroundColor,
    textSize,
    imageOptions,
    curves,
    linkOptions,
  } = props
  const heading = translations?.heading || props?.heading
  const content = translations?.content || props?.content
  const link = translations?.link || props?.link
  const { imageCrop, imageFocus, imageBorder } = imageOptions
  const linkFormat = linkOptions?.format
  const { topCurve } = curves
  const singleDocument = documents?.length === 1 && documents[0]?.document?.localFile?.publicURL
  const multipleDocuments = documents?.length > 1
  const manyDocuments = documents?.length > 8
  return (
    <section
      className={`${backgroundColor} ${topCurve !== "none" ? "mt-10" : ""} ${backgroundColor === "white"
        ? "bg-white"
        : backgroundColor === "magenta"
          ? "bg-magenta-50"
          : backgroundColor === "lightBlue"
            ? "bg-blue-50"
            : ""
        } 
          print:bg-transparent relative`}
      key={`content ${index}`}
      id={index}
    >
      {topCurve === "sm" ? (
        <CurveTSm
          className={`w-full absolute -translate-y-full top-[1px] z-10 ${backgroundColor === "white"
            ? "text-white"
            : backgroundColor === "magenta"
              ? "text-magenta-50"
              : backgroundColor === "lightBlue"
                ? "text-blue-50"
                : ""
            }`}
        />
      ) : null}
      <div className={`container py-16 
        ${topCurve !== "none" ? "pt-8" : ""} 
        ${hr ? `border-b ${backgroundColor === "magenta"
          ? "border-b-magenta-300"
          : backgroundColor === "lightBlue"
            ? "border-b-blue-300"
            : "border-b-gray-300"}`
          : ""} `}>
        <div
          className={`${(image || singleDocument)
            ? `grid items-center justify-center ${(multipleDocuments && index % 2 === 0) ? "" : `md:grid-flow-col-dense`} md:grid-cols-3 print:grid-cols-1 gap-8`
            : ""
            }`}
        >
          <div
            className={`${(image || singleDocument) ? `max-w-3xl md:col-span-2 ${index % 2 === 1
              ? "md:justify-self-start"
              : "md:justify-self-end"
              }` : "max-w-5xl"
              }`}
          >
            <div className="">
              {heading && (
                <h2 className="mb-2" data-sal="slide-up" data-sal-easing="ease">
                  {parse(heading)}
                </h2>
              )}
              {content && (
                <Html className={`parsed-content ${textSize === "lg" ? "text-lg leading-relaxed" : ""
                  }`}>{content}</Html>
              )}
              {link && (
                <>
                  {link.url?.startsWith("/") ?
                    <Link to={link.url} target={link.target} className={`${linkFormat === "button" ? "btn btn-primary mt-4" : "btn-text pt-2"}`}>
                      {link.title}
                    </Link>
                    : <a href={link.url} target="_blank" rel="noreferrer"
                      className={`${linkFormat === "button" ? "btn btn-primary mt-4" : "btn-text pt-2"}`}>
                      {link.title}
                    </a>}
                </>
              )}
            </div>
          </div>
          {image ? (
            <div
              className={`print:max-w-sm flex justify-center  ${index % 2 === 1
                ? "col-start-1 md:justify-self-end"
                : " md:justify-self-start"
                }`}
            >
              <StyledImage
                image={image}
                objectFit={imageCrop === "circle" ? "cover" : imageCrop}
                objectPosition={imageFocus}
                animated={true}
                className={`mx-auto 
                ${imageBorder && imageBorder !== "none" ?
                    (imageCrop === "circle"
                      ? `` : 'shadow-subtle')
                    : ""
                  }
                  ${imageBorder === "magenta"
                    ? ""
                    : imageBorder === "lightBlue"
                      ? "shadow-blue/20"
                      : ""
                  }
                  ${imageCrop === "circle"
                    ? "w-64 h-64 md:w-56 md:h-56 lg:w-64 lg:h-64 xl:w-72 xl:h-72 max-w-full"
                    : "max-h-64 max-w-full sm:max-w-sm md:max-w-full"
                  } `}
                imgClassName={`${imageBorder && imageBorder !== "none" ?
                  (imageCrop === "circle"
                    ? `border-10 rounded-full` : 'border-3 rounded-md')
                  : ""
                  } 
              ${imageBorder === "magenta"
                    ? "border-magenta"
                    : imageBorder === "lightBlue"
                      ? "border-blue"
                      : ""
                  } `}
              />
            </div>
          ) : null}
          {singleDocument ? (
            <div
              className={`print:max-w-sm flex justify-center  ${index % 2 === 1
                ? "col-start-1 md:justify-self-end"
                : " md:justify-self-start"
                }`}
            >
              <Document props={documents[0]} singleDocument={true} />

            </div>
          ) : manyDocuments ?
            <div className="bg-gray-50 rounded-md p-4 mt-4 col-span-full">
              <Disclosure>
                {({ open }) => (
                  <>
                    <Disclosure.Button className="p-4 bg-gray-100 w-full flex justify-between items-center rounded-md">
                      {open ? "Hide" : "Show"} {documents.length} Documents <Arrow className={`w-3 text-blue transition ${open ? "rotate-180" : ""}`} />
                    </Disclosure.Button>
                    <Disclosure.Panel className="text-gray-500">
                      <ol className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4 mt-8 px-4`}>
                        {documents.map((document, index) => <Document props={document} key={index} index={index} manyDocuments={manyDocuments} />)}
                      </ol>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            </div>
            : multipleDocuments ?
              <div className={`col-span-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-12 gap-8 xl:gap-16 mt-11`}>
                {documents.map((document, index) => <Document props={document} key={index} index={index} />)}
              </div>
              : null}
        </div>
      </div>
    </section>
  )
}
function Document({ props, index, singleDocument, manyDocuments }) {
  const { localFile, title, description, mediaDetails } = props?.document
  const image = { ...props?.preview, altText: "" }
  return (
    <>
      {localFile?.publicURL ?
        <li key={title || index} className={`flex sm:items-stretch ${manyDocuments ? "text-sm" : "justify-center items-center"}`}>
          <a href={localFile.publicURL} target="_blank" rel="noopener noreferrer" className="inline-flex flex-col items-center justify-between group text-black mb-3">
            {singleDocument ? null : <h3 className={`mb-2 ${manyDocuments ? "" : "text-center"} font-normal hover:text-black leading-tight`}>{manyDocuments ? <span className="font-bold">{index + 1}. </span> : null}{title}</h3>}
            {!manyDocuments ? <div aria-hidden className="mb-6">
              {image.localFile ?
                <StyledImage
                  image={image}
                  objectFit={"contain"}
                  animated={true}
                  className={`h-auto shadow-subtle group-hover:shadow-magenta/40 transition ${image.localFile?.childImageSharp?.gatsbyImageData?.width > image.localFile?.childImageSharp?.gatsbyImageData?.height ? "w-52" : "w-40"} `}
                  imgClassName={'rounded-md border-3 border-magenta transition'}
                />
                : (mediaDetails?.sizes && mediaDetails.sizes[0]?.sourceUrl) ?
                  <img src={mediaDetails.sizes[0].sourceUrl} alt=""
                    className={`h-auto rounded-md border-3 border-magenta shadow-subtle group-hover:shadow-magenta/40 transition ${manyDocuments ? "w-16" : mediaDetails.sizes[0].width > mediaDetails.sizes[0].height ? "w-52" : "w-40"} `}
                  />
                  :
                  <div className="w-40 rounded-md border-3 border-magenta shadow-subtle group-hover:shadow-magenta/40 transition aspect-[8.5/11] bg-gray-100 flex items-center justify-center text-magenta"><DocumentTextIcon className="w-16" strokeWidth={1} /></div>
              }
            </div> : null}
            {manyDocuments ? null : <div className="btn btn-secondary">Download {description?.replace(/<[^>]+>/g, '') || localFile.extension?.toUpperCase()}</div>}
          </a>
        </li>
        : null}
    </>
  )
}

